import { Module } from 'vuex';
import { AppState } from '..';
import { prefixValues } from '@/helpers';
import { GetOrderingStatusFeatureFlagsResponse } from '@/models/feature-flags';

export interface FeatureFlagsModuleState {
  orderingStatus: null | GetOrderingStatusFeatureFlagsResponse;
  hasFetchedFlags: boolean;
  customerFlagsKey: string;
  featureFlags: {
    isSummerOfExtrasEnabled: boolean;
    isUpdatedContextualRewardsBagUpdatesEnabled: boolean;
    isChooseYourOwnBirthdayEnabled: boolean,
    isGoogleMapsApiKeyEnabled?: boolean,
    isRewardsReferralProgramEnabled: boolean,
    isCyoRewardAndSideQuestsEnabled: boolean,
    isGooglePayWebReleaseEnabled: boolean,
    isChipotleUReverificationEnabled?: boolean,
    isSummerAmoeWeeklyEnabled: boolean,
    isSummerAmoeGrandPrizeEnabled: boolean,
  }
}

const MUTATION_NAMES = {
  SET_ORDERING_STATUS_FLAGS: 'setOrderingStatusFlags',
  SET_HAS_FETCHED_FLAGS: 'setHasFetchedFlags',
  SET_CUSTOMER_FLAGS_KEY: 'setCustomerFlagsKey',
  SET_FEATURE_FLAGS: 'setFeatureFlags',
};

export const MUTATIONS = prefixValues(MUTATION_NAMES, 'featureFlags/');

export function makeFeatureFlagsModule(): Module<FeatureFlagsModuleState, AppState> {
  return {
    namespaced: true,
    state: {
      hasFetchedFlags: false,
      orderingStatus: null,
      customerFlagsKey: '',
      featureFlags: {
        isSummerOfExtrasEnabled: false,
        isUpdatedContextualRewardsBagUpdatesEnabled: false,
        isChooseYourOwnBirthdayEnabled: false,
        isGoogleMapsApiKeyEnabled: true,
        isRewardsReferralProgramEnabled: false,
        isCyoRewardAndSideQuestsEnabled: false,
        isGooglePayWebReleaseEnabled: false,
        isChipotleUReverificationEnabled: false,
        isSummerAmoeWeeklyEnabled: false,
        isSummerAmoeGrandPrizeEnabled: false,
      }
    },
    mutations: {
      [MUTATION_NAMES.SET_ORDERING_STATUS_FLAGS](state, flags) {
        state.orderingStatus = flags;
      },
      [MUTATION_NAMES.SET_HAS_FETCHED_FLAGS](state, value) {
        state.hasFetchedFlags = value;
      },
      [MUTATION_NAMES.SET_CUSTOMER_FLAGS_KEY](state, value) {
        state.customerFlagsKey = value;
      },
      [MUTATION_NAMES.SET_FEATURE_FLAGS](state, value) {
        state.featureFlags = value;
      },
    },
  };
}
